import { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import useAuthStore from '../game/authStore';

const inputClass = "w-full py-3 px-4 rounded-xl text-sm bg-[#0f1a30] border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-white/30";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const { loading, error, resetPassword } = useAuthStore();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [mismatch, setMismatch] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMismatch(true);
      return;
    }
    setMismatch(false);
    const ok = await resetPassword(token, password);
    if (ok) setDone(true);
  };

  return (
    <div className="dark min-h-screen bg-[#1a1a2e] flex items-center justify-center p-4">
      <div className="w-full max-w-sm rounded-xl border border-white/10 bg-[#1a1a2e] p-6">
        <h2 className="text-lg sm:text-xl font-bold text-white text-center mb-1">
          Redefinir senha
        </h2>

        {!token ? (
          <p className="text-xs sm:text-sm text-red-400 text-center mt-4">
            Link inválido: token não encontrado.
          </p>
        ) : done ? (
          <>
            <div className="mt-4 p-3 rounded-lg bg-emerald-500/10 border border-emerald-500/20">
              <p className="text-xs text-emerald-300">Senha redefinida com sucesso! Você já pode entrar com sua nova senha.</p>
            </div>
            <Link
              to="/cleptocracia"
              className="w-full mt-4 py-3 rounded-xl text-sm font-bold transition-all flex items-center justify-center gap-2"
              style={{ background: 'rgba(212,165,116,.95)', color: '#111' }}
            >
              Ir para o jogo <ArrowRight size={16} />
            </Link>
          </>
        ) : (
          <>
            <p className="text-xs sm:text-sm text-gray-400 text-center mb-6">
              Escolha uma nova senha para sua conta
            </p>
            <form onSubmit={handleSubmit} className="space-y-3">
              <input
                type="password"
                placeholder="Nova senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={4}
                className={inputClass}
              />
              <input
                type="password"
                placeholder="Confirmar nova senha"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={4}
                className={inputClass}
              />
              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 rounded-xl text-sm font-bold transition-all flex items-center justify-center gap-2 disabled:opacity-50 hover:opacity-90 active:scale-[0.98]"
                style={{ background: 'rgba(212,165,116,.95)', color: '#111' }}
              >
                {loading ? (
                  <div className="animate-spin rounded-full h-5 w-5 border-2 border-current border-t-transparent" />
                ) : (
                  <>Redefinir senha <ArrowRight size={16} /></>
                )}
              </button>
            </form>

            {mismatch && (
              <div className="mt-4 p-2.5 rounded-lg bg-red-500/10 border border-red-500/20">
                <p className="text-xs text-red-400">As senhas não coincidem</p>
              </div>
            )}
            {error && !mismatch && (
              <div className="mt-4 p-2.5 rounded-lg bg-red-500/10 border border-red-500/20">
                <p className="text-xs text-red-400">{error}</p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
